import { render, staticRenderFns } from "./xeGoalCardSetting.vue?vue&type=template&id=6eb3c4fb"
import script from "./xeGoalCardSetting.vue?vue&type=script&lang=js"
export * from "./xeGoalCardSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports